export const instance = {
  state: {
    instance: null
  },
  mutations: {
    updateInstance(state, newInstance) {
      state.instance = newInstance;
    },
    removeInstance(state) {
      state.instance = null;
    }
  },
  actions: {
    bindInstance({ commit, dispatch }, instance) {
      dispatch('deleteAllSites');
      dispatch('clearCompanies');
      dispatch('logoutUser');
      commit("updateInstance", instance);
    },
    clearInstance({ commit }) {
      commit("removeInstance");
    }
  },
  getters: {
    currentInstance(state) {
      return state.instance
    }
  }
}